export default ({ currentUser, organizationPermissions, organizations }) => {
  if (currentUser.data.authority === 'superadmin') {
    return organizations.data.organizations[0].id;
  }

  return organizationPermissions.data.organization_video_permissions.find(
    (permission) => permission.allow_admin_view,
  )?.organization_id;
};
